import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable @typescript-eslint/no-explicit-any */
import * as React from 'react';
import { useElementForkRef } from '@cian/react-utils';
import { Popper } from '../../../internal/components/Popper';
import { SAME_WIDTH, FLIP } from '../../../internal/components/Popper/modifiers';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * Компонента для открытия выпадающего контента с привязкой к элементу по типу Dropdown
 *
 * Умеет открываться вверх, если снизу недостаточно места
 */
export function DropdownPopover(_ref) {
  var open = _ref.open,
    content = _ref.content,
    _ref$sameWidth = _ref.sameWidth,
    sameWidth = _ref$sameWidth === void 0 ? 'minWidth' : _ref$sameWidth,
    _ref$flip = _ref.flip,
    flip = _ref$flip === void 0 ? true : _ref$flip,
    children = _ref.children;
  var _useElementForkRef = useElementForkRef(children),
    _useElementForkRef2 = _slicedToArray(_useElementForkRef, 2),
    refferedChildren = _useElementForkRef2[0],
    childrenRef = _useElementForkRef2[1];
  var modifiers = React.useMemo(function () {
    return [sameWidth && _objectSpread(_objectSpread({}, SAME_WIDTH), {}, {
      options: _objectSpread(_objectSpread({}, SAME_WIDTH.options), {}, {
        property: sameWidth
      })
    }), flip && FLIP].filter(Boolean);
  }, [sameWidth, flip]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [refferedChildren, /*#__PURE__*/_jsx(Popper, {
      open: open,
      anchorRef: childrenRef,
      placement: "bottom-start",
      modifiers: modifiers,
      children: content
    })]
  });
}